import React from "react";
import { motion } from "framer-motion";

export const PageHeader = ({ eyebrow, title, subtitle, image }) => {
  return (
    <section className="relative w-full bg-[#1A1A1A] text-[#F9F8F6] pt-32 lg:pt-40 pb-20 lg:pb-28 overflow-hidden">
      {image && (
        <div className="absolute inset-0 opacity-35">
          <img src={image} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#1A1A1A]/40 via-transparent to-[#1A1A1A]" />
        </div>
      )}
      <div className="absolute inset-0 grain-overlay pointer-events-none" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#F9F8F6]/70 mb-6"
        >
          — {eyebrow}
        </motion.div>
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="font-display text-5xl sm:text-6xl lg:text-8xl font-light tracking-tighter leading-[0.92] max-w-5xl"
          data-testid="page-title"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="mt-8 max-w-2xl text-base lg:text-lg text-[#F9F8F6]/80 leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
};
